/**
 * A directive that can be used to render a font family.
 *
 * @example
 *  <family-card family="family"
 *               example-text="controller.exampleText"
 *               ng-repeat="family in controller.families track by family.slug">
 *  </family-card>
 *
 * @ngInject
 */
function Directive() {
  return {
    scope: {},
    bindToController: {
      cardType: '@',
      showCarousel: '@',
      exampleText: '&',
      family: '=',
      textSamples: '&',
      noBackground: '&',
      isPreviouslyActiveView: '&',
      recommendationIndex: '&',
      selectedTag: '&',
      viewType: '&'
    },
    controller: require('./controller.js'),
    controllerAs: 'familyCard',
    restrict: 'E',
    replace: true,
    templateUrl: '/angular_templates/directives/family_card.html'
  };
}

module.exports = Directive;
